/**
 * @fileoverview The i18next namespace the MFA string bundles register under.
 * @package @puffin-core/mfa-ui
 *
 * A ZERO-IMPORT leaf module, mirroring `@puffin-core/auth-shell`'s and `@puffin-core/login-shell`'s
 * `strings/namespace.js`. `useMfaTranslate()` is imported by MFA components; routing it through
 * `strings/index.js` would drag `en.js` and `es.js` into those import chains for one constant.
 */

/**
 * The canonical namespace under which MFA strings live in i18next.
 * `useMfaTranslate()` returns a translator pre-bound to it.
 */
export const MFA_NAMESPACE = 'mfa';

export default MFA_NAMESPACE;
